import React from 'react';
import { useNavigate } from "react-router-dom";
import "../admin/style/footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesRight } from "@fortawesome/free-solid-svg-icons";
import { faFacebook, faWhatsapp, faYoutube, faLinkedin, faInstagram } from "@fortawesome/free-brands-svg-icons";
import Domin from "../images/domin.png";
import Logo from "../images/logo.jpeg";

// Footer Component
const Footer = () => {
  const navigate = useNavigate(); // Move useNavigate inside the component

  const handleNavigation = (path) => {
    navigate(path); // Navigate when a link is clicked
  };

  return (
    <div>
      <footer>
        <section className='section1'>
          <h3>EXPLORE</h3>
          <div className='box'>
            <div>
              <li onClick={() => handleNavigation("/")}>
                <FontAwesomeIcon icon={faAnglesRight} id='icon' />Home
              </li>
              <li onClick={() => handleNavigation("/Contactus")}>
                <FontAwesomeIcon icon={faAnglesRight} id='icon' />Contact Us
              </li>
              <li onClick={() => handleNavigation("/Admin")}>
                <FontAwesomeIcon icon={faAnglesRight} id='icon' />Admin
              </li>
              <li onClick={() => handleNavigation("/Aboutus")}>
                <FontAwesomeIcon icon={faAnglesRight} id='icon' />About Us
              </li>
              <li onClick={() => handleNavigation("/Acadamics")}>
                <FontAwesomeIcon icon={faAnglesRight} id='icon' />Academics
              </li>
              <li onClick={() => handleNavigation("/Hostel")}>
                <FontAwesomeIcon icon={faAnglesRight} id='icon' />Hostel
              </li>
              <li onClick={() => handleNavigation("/")}>
                <FontAwesomeIcon icon={faAnglesRight} id='icon' />Hostel/login
              </li>
            </div>
            <div>
              <li onClick={() => handleNavigation("/general")}>
                <FontAwesomeIcon icon={faAnglesRight} id='icon' />Department/General
              </li>
              <li onClick={() => handleNavigation("/Cse")}>
                <FontAwesomeIcon icon={faAnglesRight} id='icon' />Department/CME
              </li>
              <li onClick={() => handleNavigation("/Ece")}>
                <FontAwesomeIcon icon={faAnglesRight} id='icon' />Department/ECE
              </li>
              <li onClick={() => handleNavigation("/Mech")}>
                <FontAwesomeIcon icon={faAnglesRight} id='icon' />Department/EEE
              </li>
              <li onClick={() => handleNavigation("/EEE")}>
                <FontAwesomeIcon icon={faAnglesRight} id='icon' />Department/Mech
              </li>
              <li onClick={() => handleNavigation("/Events")}>
                <FontAwesomeIcon icon={faAnglesRight} id='icon' />Events
              </li>
              <li onClick={() => handleNavigation("/login")}>
                <FontAwesomeIcon icon={faAnglesRight} id='icon' />Events/Login
              </li>
            </div>
          </div>
        </section>

        <section className='section3'>
          <h3>Mail ID's</h3>
          <div>
            <p>College: <a href="mailto:rp.kuppam101@gmail.com" className="email-link">rp.kuppam101@gmail.com</a></p>
            <p>Office: <a href="mailto:gp101office@gmail.com" className="email-link">gp101office@gmail.com</a></p>
            <p>DCME: <a href="mailto:gpt101.cme@gmail.com" className="email-link">gpt101.cme@gmail.com</a></p>
            <p>DECE: <a href="mailto:gpt101.ece@gmail.com" className="email-link">gpt101.ece@gmail.com</a></p>
            <p>DEEE: <a href="mailto:gpt101.eee@gmail.com" className="email-link">gpt101.eee@gmail.com</a></p>
            <p>DME: <a href="mailto:rp.gpt101.me@gmail.com" className="email-link">gpt101.eee@gmail.com</a></p>
          </div>
        </section>

        <section className='section2'>
          <h3>ADDRESS</h3>
          <div> <a href="https://www.google.com/maps?rlz=1C1UEAD_enIN1092IN1092&um=1&ie=UTF-8&fb=1&gl=in&sa=X&geocode=Kac1RnK0ua07MfE9mdIlbAO6&daddr=near+model+colony,+Yanadipalle,+Andhra+Pradesh+517425" className="email-link">
            <p>YANADIPALLI VILLAGE, KRISNADASANA <br />PALLI (POST) KUPPAM - 517425, <br />
              CHITTOOR (D.T), ANDHRA PRADESH: 8367799101, 08570 - 255444

            </p>
          </a>
            <h3 style={{ margin: "10px 0 0 0" }}>CONTACT US</h3>

            <div>
              <p >
                Call us now:
              </p>

              <a href="tel:08570255444" className="email-link">08570-255444</a>,
            </div>
            <div>
              <a href="tel:8367799101 " className="email-link">8367799101</a>
            </div>

            {/* <p>Mail: <a href="mailto:rp.kuppam101@gmail.com" class="email-link">rp.kuppam101@gmail.com</a></p> */}

            <div className="social-icons">
              <h3>FOLLOW US</h3>
              <div className='social'>
                <a href="https://m.facebook.com/jamesyenruralpolytechnic/">
                  <FontAwesomeIcon icon={faFacebook} className="social-icon" />
                </a>
                <a href="https://www.whatsapp.com/channel/0029VaPwbNc7YSczfs8ogG03">
                  <FontAwesomeIcon icon={faWhatsapp} className="social-icon" />
                </a>
                <a href="https://youtube.com/@gptkuppam2986?si=b0BrM76TslTEkSad">
                  <FontAwesomeIcon icon={faYoutube} className="social-icon" />
                </a>
                <a href="https://in.linkedin.com/company/gptkuppam">
                  <FontAwesomeIcon icon={faLinkedin} className="social-icon" />
                </a>
                <a href="https://www.instagram.com/ycjamesyengovtpolytechnic?igsh=MTRuc25ic2t0dXF3Ng==">
                  <FontAwesomeIcon icon={faInstagram} className="social-icon" />

                </a>
              </div>
            </div>
          </div>
        </section>

        <section className='section3'>
          <h3>SUPPORT</h3>
          <div>
            <p>For any assistance, including technical, academic, financial, or administrative support, please contact our helpdesk or support team.</p>
            <h3>VISIT TIME:</h3>
            <p>Visit time: Mon-Sat 9:30 AM - 04:30 PM</p>
            <img src={Domin} alt="Domin Image" />
            <div className='image'>
              <img src={Logo} alt="Logo" />
              <p>Copyright © 2024-2025</p>
            </div>
            <p>gptkpm.in Solutions Inc. All Rights Reserved. All other trademarks and copyrights are the property of their respective holders.</p>
          </div>
        </section>

      </footer>
    </div>
  );
};

export default Footer;
